import { NGXLoggerServerService } from 'ngx-logger';
import { inject, Injectable, NgZone } from '@angular/core';
import { HttpBackend, HttpRequest, HttpXsrfTokenExtractor } from '@angular/common/http';

@Injectable()
export class CustomLoggerServerService extends NGXLoggerServerService {
  private readonly xsrfTokenExtractor = inject(HttpXsrfTokenExtractor);

  constructor() {
    const httpBackend = inject(HttpBackend);
    const ngZone = inject(NgZone);

    super(httpBackend, ngZone);
  }

  protected override alterHttpRequest(httpRequest: HttpRequest<any>): HttpRequest<any> {
    const csrfToken = this.xsrfTokenExtractor.getToken();
    const csrfHeaderName = 'X-XSRF-TOKEN';
    if (csrfToken && !httpRequest.headers.has(csrfHeaderName)) {
      return httpRequest.clone({ headers: httpRequest.headers.set(csrfHeaderName, csrfToken) });
    } else {
      return httpRequest;
    }
  }
}
